import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import {
  SHARE_DASHBOARD_URL_PATH,
  SHARE_SAVED_QUERY_URL_PATH,
  SHARING_URL_PATH,
} from './paths';

const SharedDashboard = React.lazy(() => import('@/views/SharedDashboard'));
const SharedSavedQuery = React.lazy(() => import('@/views/SharedSavedQuery'));

export default {
  path: SHARING_URL_PATH,
  element: <Outlet />,
  children: [
    {
      path: SHARE_SAVED_QUERY_URL_PATH,
      element: <SharedSavedQuery />,
    },
    {
      path: SHARE_DASHBOARD_URL_PATH,
      element: (
        <ErrorBoundary>
          <SharedDashboard />
        </ErrorBoundary>
      ),
    },
  ],
};
